import * as service from './profile';

export default service;
